export default __webpack_public_path__ + "static/media/GHSI Employee Feedback Guideline.72b866c5.pdf";